const messages = {
  global: {
    tenant: "Mandant|Mandanten",
    tenants: "0 Mandanten|1 Mandant|{n} Mandanten",
    site: "Standort|Standorte",
    sites: "0 Standorte|1 Standort|{n} Standorte",
    day: "Tag|Tage",
    days: "0 Tage|1 Tag|{n} Tage",
    any: "Beliebig",
    or: "oder",
    options: "Option|Optionen",
    attachments: "Anhänge",
    noAttachments: "Keine Anhänge",
    error: "Fehler",
    all: "Alle",
    list: "Liste",
    onDate: "am",
    atTime: "um",
    by: "von",
    copy: "Kopie",
    clone: "Klon",
    propertiesShort: "Eig.",
    role: "Rolle|Rollen",
    assignedRoles: "Zugewiesene Rolle|Zugewiesene Rollen",
    anonymousUser: "Anonymer Benutzer",
    unset: "Nicht gesetzt",
    picture: "Bild|Bilder",
  },
  action: {
    ok: "OK",
    apply: "Anwenden",
    confirm: "Bestätigen",
    cancel: "Abbrechen",
    close: "Schliessen",
    select: "Auswählen",
    yes: "Ja",
    no: "Nein",
    save: "Speichern",
    create: "Erstellen",
    add: "Hinzufügen",
    edit: "Bearbeiten",
    complete: "Abschliessen",
    stopEdit: "Bearbeitung beenden",
    refresh: "Aktualisieren",
    clear: "Zurücksetzen",
    clearAll: "Alle entfernen",
    remove: "Entfernen",
    upload: "Hochladen",
    download: "Herunterladen",
    delete: "Löschen",
    back: "Zurück",
    send: "Senden",
    search: "Suchen",
    newEllipsis: "Neu...",
    moreEllipsis: "Mehr...",
    addEllipsis: "Hinzufügen...",
    selectEllipsis: "Auswählen...",
    copyEllipsis: "Kopieren...",
    cloneEllipsis: "Klonen...",
    captureEllipsis: "Erfassen...",
    goto: "Gehe zu: {name}",
    loginWithPasskey: "Anmelden mit einem Passkey",
    loginWithMicrosoft: "Anmelden mit Microsoft",
    confirmQuantity: "Menge bestätigen",
    showBarcode: "Barcodes anzeigen",
    developerMode: "Entwickler-Modus",
    showLotVisual: "Charge visualisieren",
    showAuditVisual: "Audit visualisieren",
    colorModeSystem: "System",
    colorModeLight: "Hell",
    colorModeDark: "Dunkel",
    requestQuantityInput: "manuell",
    scan: "Scannen",
    scanBarcode: "Barcode scannen",
    scanItem: "Artikel scannen",
    addToList: "Zur Liste hinzufügen",
    addPasskey: "Passkey hinzufügen",
    linkMicrosoftAccount: "Microsoft-Konto verknüpfen",
    copyToClipboard: "Kopieren",
    copyToExtension: "Kopieren",
    placeOrder: "Bestellen",
    fillDemands: "Bedarf sync.",
    acceptOrder: "Bestellung bestätigen",
    consumeListed: "Alle verbrauchen",
    printPreviewEllipsis: "Etikettenansicht...",
    printEllipsis: "Drucken...",
    showPast: "Vergangene",
    resendEmail: "E-Mail erneut senden",
    ignore: "Ignorieren",
    discardAndLeave: "Verwerfen und verlassen",
    ignoreSignature: "Signatur (Charge / Mindesthaltbarkeit / Verfall) ignorieren und Artikel-Summen anzeigen",
    reorder: "Erneut bestellen",
    addToDraft: "Zu Entwurf hinzufügen",
    addToCart: "In den Warenkorb",
    addToNewOrderEllipsis: "Zu neuer Bestellung hinzufügen...",
    addToOrderDraft: "In den Warenkorb",
    verifyConnection: "Verbindung prüfen",
    ttsRead: "Vorlesen",
    asrRecognize: "Spracherkennung",
    viewMail: "E-Mail anzeigen",
    viewMailInMyLanguage: "E-Mail in meiner Sprache anzeigen",
    "show-all": "Alle zeigen",
    revoke: "Widerrufen",
    cancelOrderShort: "Stornieren",
    triggeredPageReload: "App wird neu geladen -> {reason}",
    goHome: "Zur Startseite",
    undoStockChange: "Bestandsänderung rückgängig machen (soweit möglich)",
  },
  status: {
    none: "",
    pending: "Ausstehend",
    inProgress: "In Bearbeitung",
    completed: "Abgeschlossen",
    succeeded: "Erfolgreich",
    cancelled: "Abgebrochen",
    failed: "Fehlgeschlagen",
    orderCancelledShort: "Storniert",
    loadingEllipsis: "Lade Daten...",
    savingEllipsis: "Speichere Daten...",
  },
  reason: {
    reloadPageForcedByServer: "Erzwungen von Server",
    reloadPageNewServerBuild: "Neuer Server Build",
    reloadPageAssetChanged: "Neue Assets",
    partialDelivery: "Teillieferung",
    partialDeliveryIgnored: "Teillieferung (ignoriert)",
    partialDeliveryReordered: "Teillieferung (bestellt)",
    partialDeliveryMissingItemsCopiedToDraftOrder: "Teillieferung (geplant)",
  },
  enum: {
    restockPullType: {
      "0": "Bestellung",
      "1": "Min-Max",
      "2": "Gebinde Min-Max",
    },
  },
  instruction: {
    confirmQuantitySummary: "Menge nach dem Scannen bestätigen, anstatt die Menge direkt zu buchen.",
    showBarcodeSummary: "Barcodes von Lager- und gelieferten Artikeln in Listen anzeigen.",
    developerModeSummary: "Für die Fehlersuche benötigte Informationen anzeigen (Debug-Modus).",
    showLotVisualSummary: "Einen visuellen Indikator für die Charge anzeigen, um die Charge auf einen Blick unterscheiden zu können.",
    showAuditVisualSummary: "Benutzer mit farblichem Hintergrund anzeigen, um unterschiedliche Benutzer auf einen Blick unterscheiden zu können.",
    restockPullTypeOriginalPack: "Scan wenn Packung leer",
    provideRequiredFields: "Bitte füllen Sie die erforderlichen Felder aus.",
    requiresAtLeaseTwoEntries: "Mindestens zwei Einträge erforderlich",
    undoStockChangeConfirm: "Diese Bestandsänderung rückgängig machen? Reicht der aktuelle Bestand nicht mehr für die ursprüngliche Änderung, wird die Rücknahme auf den verfügbaren Bestand begrenzt.",
    unsavedChangesTitle: "Nicht gespeicherte Änderungen",
    unsavedChangesLeaveConfirm: "Es gibt nicht gespeicherte Änderungen. Seite verlassen und Änderungen verwerfen?",
  },
  help: {
    assignItemsToSupplierWithoutItems: "Bearbeiten Sie den Lieferanten, um Artikel zuzuweisen.",
  },
  placeholder: {
    newSupplier: "<Neuer Lieferant>",
  },
  validation: {
    required: "Feld ist erforderlich",
    minLength: "Mindestens {min} Zeichen erforderlich",
    maxLength: "Maximal {max} Zeichen erlaubt",
    codeRequired: "Code ist erforderlich",
    nameRequired: "Name ist erforderlich",
    emailRequired: "E-Mail Adresse ist erforderlich",
    emailMustBeValid: "E-Mail Adresse muss gültig sein",
    emailType: "E-Mail Adresse muss gültig sein",
    passwordRequired: "Kennwort ist erforderlich",
    passwordMinLength: "Kennwort muss mindestens {min} Zeichen lang sein",
    confirmPasswordRequired: "Kennwortbestätigung ist erforderlich",
    passwordConfirmMatch: "Passwörter müssen übereinstimmen",
    requiredPermissions: "Erforderliche Berechtigungen: {permissions}",
    duplicateCodes: "Doppelte Codes: {duplicates}",
  },
  statement: {
    contentCopied: "Inhalt kopiert",
    itemCopied: "Artikelnummer {item} kopiert",
    emailSent: "Eine E-Mail wurde gesendet.",
    supplierSaved: "Lieferant {supplierCode} gespeichert",
    itemBlockSaved: "Artikelblock gespeichert",
    orderIsAccepted: "Bestellung wurde bestätigt",
    orderIsCancelled: "Bestellung wurde storniert",
    receivingIsAccepted: "Wareneingang wurde bestätigt",
    foreignItemSaved: "PMS-Artikel gespeichert",
    consumptionSaved: "Verbrauch gespeichert",
    partialDeliveryMissingItemsCopiedToDraftOrder: "Fehlende Artikel in Bestell-Entwurf kopiert",
    partialDeliveryMissingItemsReordered: "Fehlende Artikel erneut bestellt",
    partialDeliveryIgnored: "Teillieferung ignoriert",
  },
  error: {
    accessDenied: "Zugriff verweigert",
    pageAccessDenied: "Zugriff auf diese Seite verweigert",
    copiedError: "Fehler beim Kopieren",
    axiosErrorMessage: "{code}: {message}",
    apiError: "API Fehler: {error}",
    noData: "Keine Daten verfügbar",
    unknownItem: "Unbekannter Artikel",
    noLabelsToPrint: "Keine Etiketten zum Drucken",
    nothingToSave: "Nichts zu speichern",
    noCode: "Kein Code",
    noItemGtin: "Keine GTIN für Artikel #{itemId}",
    noHtmlMailAvailable: "Keine HTML E-Mail verfügbar",
    failedToLoadHtmlMail: "Fehler beim Laden der HTML E-Mail",
    supplierHasNoAssignedItems: "Lieferant '{supplierName}' hat keine zugewiesenen Artikel",
    baseItemNotFoundForItem: "Basisartikel #{baseItemId} nicht gefunden für Artikel '{itemCode}'",
    itemNotManagedByDemand: "Artikel '{itemCode}' ist nicht für Bestellung vorgesehen",
    itemManagedByStockLevels: "Artikel '{itemCode}' ist für automatischen Nachschub vorgesehen",
    noItemSupplierAssigned: "Kein Lieferant zugewiesen",
    noSupplierFoundForItem: "Kein Lieferant gefunden für Artikel '{itemCode}'",
    noSupplierItemFoundForItem: "Kein Lieferantenartikel gefunden für Artikel '{itemCode}' für Lieferant #{supplierId}, Lieferantenartikel {{supplierItemId}} ({supplierItemCode})",
    supplierSaveError: "Fehler beim Speichern des Lieferanten: {error}",
    requiresValidSignature: "Artikeleigenschaften notwendig / automatisch abbuchen deaktiviert '{itemCode}'",
    notEnoughStockShort: "Nicht genügend Bestand! Angefordert {quantity} {unitName}, verfügbar {available} {unitName}",
    notEnoughStock: "Nicht genügend Bestand für Artikel '{itemCode}', angefordert {quantity} {unitName}, verfügbar {available} {unitName}",
    invalidPatientCode: "Ungültige Patientennummer: {patientCode}",
  },
  menu: {
    home: "Startseite",
    controlling: "Kontrolle",
    masterdata: "Stammdaten",
    administration: "Verwaltung",
    "manage-users": "Benutzer verwalten",
    "manage-tenants": "Mandanten verwalten",
    "manage-sites": "Standorte verwalten",
    tenant: "Mandant",
    site: "Standort",
    items: "Artikel",
    "item-edit": "Artikel",
    "itemblocks": "Artikelblöcke",
    "itemblock-create": "Artikelblock anlegen",
    "foreign-items": "PMS-Artikel",
    suppliers: "Lieferanten",
    "info-request": "Info",
    "info-device": "Gerät",
    deliveries: "Lieferungen",
    orders: "Bestellungen",
    "order-create": "Bestellung anlegen",
    "order-list": "Liste Bestellungen",
    receivings: "Wareneingang",
    consumption: "Verbrauch",
    "consumption-list": "Liste Verbrauch",
    stocks: "Bestände",
    "stock-changes": "Bestandsverlauf",
    "stock-demand": "Nachschubbedarf",
    "order-demand": "Bestellbedarf",
    "stock-receipt": "Zugang",
    "stock-issue": "Abgang",
    "label-item": "Artikeletiketten",
    "label-box": "Gebindeetiketten",
    statistics: {
      consumption: "Verbräuche",
      expiry: "Verfall",
    },
    "label-printers": "Labeldrucker",
    "label-printer-edit": "Drucker",
    "label-templates": "Labelvorlagen",
    "label-template-edit": "Labelvorlage",
    "order-confirmation": "Bestellbestätigung",
  },
  language: {
    en: "Englisch",
    de: "Deutsch",
    fr: "Französisch",
  },
  field: {
    generic: {
      code: "Code",
      name: "Name",
      status: "Status",
      description: "Beschreibung",
      general: "Allgemein",
      password: "Kennwort",
      token: "Token",
      rowActions: "",
      id: "ID",
      email: "E-Mail",
      quantity: "Menge",
      item: "Artikel",
      tradeItem: "EAN|EANs",
      supplier: "Lieferant|Lieferanten",
      customer: "Kunde|Kunden",
      address: "Adresse",
      phone: "Telefon",
      created: "Erstellt",
      updated: "Geändert",
      itemblock: "Artikelblock",
      company: "Firma",
      contactName: "Kontaktname",
      order: "Bestellung|Bestellungen",
      delivery: "Lieferung|Lieferungen",
      linesCount: "Pos.",
      language: "Sprache",
    },
    user: {
      fullName: "Vollständiger Name",
      fullNamePlaceholder: "Vorname Nachname",
    },
    emailQueue: {
      statusLabel: "E-Mail Status",
    },
    masterdata: {
      itemCode: "Art.Nr.",
      orderUnitCode: "Bestelleinheit",
      trackStock: "Bestand?",
      lot: "Charge",
      bestBefore: "MHD",
      expiry: "Verfallsdatum",
      patientCode: "Pat.Nr.",
    },
    export: {
      exportStatus: "Exportstatus",
      exportReference: "Exportreferenz",
      exportResult: "Exportergebnis",
    },
    item: {
      unitName: "Einheit",
      restockPullType: "NV",
      allowCalculatedSignature: "AA",
    },
    tradeItem: {
      unitCode: "Einheit",
      factor: "Faktor",
      defaultUnitCode: "ST",
    },
    foreignItem: {
      itemCode: "PMS Art.Nr.",
    },
    itemBlock: {
      code: "Code (QR)"
    },
    supplier: {
      supplierCode: "Lieferanten Nr.",
      supplierCodeTitle: "Kreditorennummer",
      customerCode: "Kunden Nr.",
      customerCodeTitle: "Debitorennummer",
      assignedSupplier: "Zugewiesener Lieferant",
      assignedItems: "Zugewiesene Artikel",
      itemCode: "REF",
      cultureName: "E-Mail-Sprache",
      cultureNameTitle: "Sprache für Bestell-E-Mails an diesen Lieferanten",
      autoConfirmOrder: "Bestellung automatisch bestätigen",
      autoConfirmOrderTitle: "Die Bestellung dieses Lieferanten wird automatisch bestätigt, ohne ein Lieferdatum abzufragen",
      autoOrderEnabled: "Bestellungen automatisch erstellen",
      autoOrderEnabledTitle: "Beim täglichen Auto-Bestelllauf werden Bestellungen für die Artikel dieses Lieferanten erstellt. Wenn deaktiviert, verbleiben die Bedarfe im Entwurf und können manuell bestellt werden.",
    },
    order: {
      orderedQuantity: "Bestellmenge",
      deliveryDate: "Lieferdatum",
    },
    fidoCredential: {
      lastUsedPlatformInfo: "Zuletzt benutzte Plattform",
    },
    entraLogin: {
      displayName: "Anzeigename",
    },
    serviceConnection: {
      endpointURL: "Server-URL",
    },
    credential: {
      type: "Anmeldeverfahren",
      username: "Benutzername",
      password: "Kennwort",
      authenticatorSecret: "Authentifikator",
    },
    receiving: {
      deliveredQuantity: "Geliefert",
    },
    consumption: {
      billable: "Verrechnen",
      billableShort: "Verr.",
      nonBillable: "Nicht verrechnen",
      nonBillableShort: "n. verr.",
    },
    pms: {
      mandator: "PMS Mandant",
    },
  },
  page: {
    home: {
      heading: "Willkommen bei Melodi",
    },
    login: {
      heading: "Anmeldung",
      rememberme: "Angemeldet bleiben",
      signin: "Anmelden",
      forgotPassword: "Kennwort vergessen?",
    },
    "forgot-password": {
      heading: "Kennwort vergessen",
      description: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Kennworts.",
    },
    "reset-password": {
      heading: "Kennwort zurücksetzen",
      description: "Bitte geben Sie Ihr neues Kennwort ein.",
      confirmPassword: "Kennwort bestätigen",
      submit: "Bestätigen",
      resetSuccess: "Ihr Kennwort wurde erfolgreich zurückgesetzt.",
      resetError: "Ihr Kennwort konnte nicht zurückgesetzt werden.",
    },
    "accept-invite": {
      heading: "Als neuer Benutzer registrieren",
      description: "Bitte geben Sie Ihren Namen und neues Kennwort ein.",
      confirmPassword: "Kennwort bestätigen",
      submit: "Bestätigen",
      userRegistrationSuccess: "Ihr Benutzerkonto wurde erfolgreich erstellt.",
      userRegistrationError: "Ihr Benutzerkonto konnte nicht erstellt werden.",
    },
    profile: {
      developer: "Entwickler",
      manageThisSettingOnDesktop: "Einstellung auf dem Desktop verwalten",
      apiKey: "API Schlüssel",
      passkeys: "Passkeys",
      generateApiKey: "API Schlüssel generieren",
      removeApiKey: "API Schlüssel entfernen",
      generateApiKeyTitle: "API Schlüssel",
      apiKeyReplaceWarning: "Das Generieren eines neuen API Schlüssels macht den aktuellen Schlüssel ungültig.",
      apiKeyShownOnceWarning: "Der API Schlüssel wird nur einmal angezeigt. Bitte speichern Sie ihn bevor Sie die Seite verlassen.",
      apiKeyCreating: "API Schlüssel wird erstellt...",
      apiKeyCreated: "API Schlüssel wurde erstellt.",
      apiKeyCreateError: "Fehler beim Erstellen des API Schlüssels: {error}",
      apiKeyDeleting: "API Schlüssel wird gelöscht...",
      apiKeyDeleted: "API Schlüssel wurde gelöscht.",
      apiKeyDeleteError: "Fehler beim Löschen des API Schlüssels: {error}",
      apiKeyCopied: "API Schlüssel wurde in die Zwischenablage kopiert.",
      apiKeyCopiedError: "Fehler beim Kopieren des API Schlüssels in die Zwischenablage.",
      loginToken: "Anmelde-QR",
      generateLoginToken: "Generiere Anmelde-QR",
      removeLoginToken: "Entferne Anmelde-QR",
      loginTokenReplaceWarning: "Das Generieren eines neuen Anmelde-QR Codes macht den aktuellen QR Code ungültig.",
      loginTokenCreating: "Anmelde-QR wird erstellt...",
      loginTokenCreated: "Anmelde-QR wurde erstellt.",
      loginTokenCreateError: "Fehler beim Erstellen des Anmelde-QR Codes: {error}",
      loginTokenDeleting: "Anmelde-QR wird gelöscht...",
      loginTokenDeleted: "Anmelde-QR wurde gelöscht.",
      loginTokenDeleteError: "Fehler beim Löschen des Anmelde-QR Codes: {error}",
      loginTokenCopied: "Anmelde-QR wurde in die Zwischenablage kopiert.",
      loginTokenCopiedError: "Fehler beim Kopieren des Anmelde-QR Codes in die Zwischenablage.",
      linkedServicesTitle: "Verknüpfte Systeme",
      addLinkedService: "System hinzufügen",
      logout: "Abmelden",
      verifyingConnection: "Verbindung wird geprüft...",
      connectionSuccessful: "Verbindung erfolgreich geprüft",
      connectionFailed: "Verbindung fehlgeschlagen",
      serviceLinkSaved: "Systemverknüpfung gespeichert",
      serviceLinkDeleted: "Systemverknüpfung gelöscht",
      invalidServiceConfiguration: "Ungültige Systemkonfiguration",
      failedToVerifyConnection: "Verbindungsprüfung fehlgeschlagen",
      failedToSave: "Speichern fehlgeschlagen",
      failedToDelete: "Löschen fehlgeschlagen",
      entraLogins: "Microsoft-Konto",
      noEntraLogins: "Kein Microsoft-Konto verknüpft.",
      entraLinkError: "Fehler beim Verknüpfen des Microsoft-Kontos.",
    },
    entra: {
      processing: "Microsoft-Anmeldung wird verarbeitet...",
      missingParameters: "Fehlende Autorisierungsparameter.",
      invalidState: "Ungültiger Autorisierungsstatus.",
      unknownError: "Ein unbekannter Fehler ist aufgetreten.",
    },
    "manage-tenants": {
      form: {
        title: "Mandanten verwalten",
      },
      tenantCreated: "Mandant {name} erstellt",
      tenantUpdated: "Mandant {name} aktualisiert",
      tenantDeleted: "Mandant {name} gelöscht",
      siteCreated: "Standort {name} erstellt",
      siteUpdated: "Standort {name} aktualisiert",
      siteDeleted: "Standort {name} gelöscht",
    },
    "manage-users": {
      form: {
        title: "Benutzer verwalten",
        inviteUser: "Benutzer einladen",
      },
      newUserTitle: "Neuer Benutzer",
      newUserEllipsis: "Neuer Benutzer...",
      usersList: "Benutzer",
      user: "Benutzer",
      deleteUser: "Benutzer löschen",
      deleteUserConfirmation: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
      inviteUserSuccess: "Benutzer eingeladen",
      inviteUserError: "Fehler beim Einladen des Benutzers: {error}",
      selectAtLeastOneRole: "Wählen Sie mindestens eine Rolle!",
      userChangSaveSuccess: "Benutzeränderungen gespeichert",
      userChangeSaveError: "Fehler beim Speichern der Benutzeränderungen: {error}",
    },
    supplier: {
      deleteConfirmTitle: "Lieferant löschen",
      deleteConfirmMessage: "Sind Sie sicher, dass Sie den Lieferanten '{supplierName}' ({supplierCode}) löschen möchten?",
    },
    site: {
      title: "Wählen Sie Ihren Standort",
    },
    item: {
      table: {
        description: "Beschreibung",
        baseUnitCode: "Basiseinheitcode",
        consumerUnitCode: "Konsumenteneinheitcode",
        consumerUnitName: "GTIN",
        logisticUnitCode: "Logistikeinheitcode",
        logisticUnitName: "VPE",
        logisticUnitFactor: "Logistikeinheitfaktor",
        tracking: "Tracking",
        trackLotNumber: "Charge?",
        trackBestBeforeDate: "MHD?",
        trackExpirationDate: "Verfallsdatum?",
        bestBeforeLeadTime: "MHD Meldezeit",
        expirationLeadTime: "Verfall Meldezeit",
        isBillable: "Verrechenbar?",
        isBillableShort: "VR",
        canOrderManually: "Manuell bestellbar?",
        requiresLabel: "Etikett?",
        allowCalculateLot: "Charge autom. abbuchen?",
      },
      form: {
        description: "Beschreibung",
        mainImage: "Produktbild",
        sizeImage: "Abmessungsbild",
        sizeMiniImage: "kleines Abmessungsbild",
        defaultLabelQuantity: "Menge Gebindeetikett",
        defaultLabelTemplate: "Standardetikette",
        restockPullType: "Nachversorgungsart",
      },
      saved: "Artikel gespeichert",
      saveError: "Fehler beim Speichern",
      openOrders: {
        title: "Offene Bestellungen",
        openQuantity: "Offen",
        replacementOf: "Ersatz: {code} ({name})",
      },
      draftCart: {
        title: "Im Warenkorb",
      },
    },
    info: {
      form: {
        title: "Info",
        barcodeOrItemCode: "Barcode oder Artikelnummer",
      },
    },
    device: {
      screen: "Bildschirm",
      displayResolution: "Anzeigauflösung",
      displayViewport: "Anzeigebereich",
      network: "Netzwerk",
      remoteAddress: "Remote-Adresse",
      userAgent: "User-Agent",
    },
    stock: {
      successMessage: "Bestände angepasst",
      errorMessage: "Fehler beim Buchen von Artikel: {item}",
      itemSourceAll: "Quelle",
      itemSourceMelodi: "Melodi",
      itemSourceExternal: "Extern",
    },
    stockDemand: {
      table: {
        quantityDemand: "Bedarfsmenge",
        quantityOrdered: "Bestellmenge",
        quantityDelivered: "Geliefert",
        stockQuantity: "Bestand",
        stockHistory: "Bestandsverlauf",
      },
    },
    stockReceipt: {
      form: {
        title: "Zugang",
        confirm: "Zugang buchen",
      },
      successMessage: "{quantity} {unit} zum Bestand hinzugefügt",
      errorMessage: "Fehler beim Buchen des Zugangs: {error}",
    },
    stockIssue: {
      form: {
        title: "Abgang",
        confirm: "Abgang buchen",
      },
      successMessage: "{quantity} {unit} vom Bestand abgebucht",
      errorMessage: "Fehler beim Buchen des Abgangs: {error}",
    },
    labelPrint: {
      form: {
        title: "Drucken",
        confirm: "Etikett drucken",
      },
      successMessage: "Etikett an {printer} gesendet",
      noTradeItemDefined: "Artikel {itemCode} hat keinen GTIN!",
    },
    labelPrinter: {
      table: {
        address: "Netzwerkadresse",
      },
      form: {
        address: "Netzwerkadresse",
        confirm: "Drucker speichern",
      },
      saved: "Drucker gespeichert",
      saveError: "Fehler beim Speichern",
      deleteError: "Fehler beim Löschen",
      deleteConfirmTitle: "Labeldrucker löschen",
      deleteConfirmMessage: "Möchten Sie den Labeldrucker '{code}' wirklich löschen?",
      deletedSuccessfully: "Labeldrucker '{code}' erfolgreich gelöscht",
    },
    labelTemplate: {
      table: {
        templateContent: "Labelvorlage",
      },
      form: {
        templateContent: "Labelvorlage",
        confirm: "Label speichern",
      },
      saved: "Label gespeichert",
      saveError: "Fehler beim Speichern",
      deleteError: "Fehler beim Löschen",
      deleteConfirmTitle: "Labelvorlage löschen",
      deleteConfirmMessage: "Möchten Sie die Labelvorlage '{code}' wirklich löschen?",
      deletedSuccessfully: "Labelvorlage '{code}' erfolgreich gelöscht",
    },
    delivery: {
      form: {
        deliveryCode: "Lieferschein Code",
        deliveryCodeHelp: "Scannen oder geben Sie den Lieferschein Code ein",
        book: "Lieferung einbuchen",
      },
      list: {
        title: "Lieferungen",
      },
      notFoundError: "Lieferung nicht gefunden",
      deliveryNotFoundError: "Lieferung {deliveryCode} nicht gefunden",
      differentSiteWarning: "Lieferung ist für einen anderen Standort",
      completeError: "Lieferung konnte nicht bestätigt werden: {error}",
      completed: "Lieferung {deliveryCode} bestätigt",
    },
    order: {
      form: {
        orderCode: "Bestellcode",
        orderCodeHelp: "Scannen oder geben Sie den Bestellcode ein",
      },
      notFoundError: "Bestellung nicht gefunden",
      orderNotFoundError: "Bestellung {orderCode} nicht gefunden",
      notInProgressError: "Bestellung {orderCode} ist nicht in Bearbeitung und kann nicht empfangen werden",
      acceptError: "Bestellung konnte nicht bestätigt werden: {error}",
      accepted: "Bestellung {orderCode} bestätigt",
    },
    "order-create": {
      nothingToOrder: "Nichts zu bestellen",
      orderSaving: "Bestellung wird gespeichert...",
      orderSaved: "Bestellung gespeichert: {orderCode}",
      ordersSaved: "Bestellung(en) gespeichert",
      orderSaveError: "Fehler beim speichern der Bestellung: {error}",
      quantitiesConfirmedFor: "{quantity} {unitCode} bestätigt auf {date}",
      quantitiesOrderedSince: "{quantity} {unitCode} offen seit {date}",
      addedToOrderDraft: "Artikel in den Warenkorb gelegt",
      addToOrderDraftError: "Fehler beim Hinzufügen in den Warenkorb",
      help: {
        title: "Seitenhilfe",
        topics: {
          placeOrder: {
            title: "Bestellen",
            description: "Erstellt aus den Artikeln im Warenkorb je Lieferant eine Bestellung und sendet jedem Lieferanten eine Bestell-E-Mail in der für ihn hinterlegten Sprache. Anschließend wird der Warenkorb geleert und Sie kehren zur Bestellliste zurück.",
          },
          fillDemands: {
            title: "Bedarf synchronisieren",
            description: "Legt Min/Max-verwaltete Artikel mit aktuellem Bedarf in den Warenkorb. Bereits offene Bestellungen werden berücksichtigt; Mengen werden auf die Bestelleinheit des Lieferanten aufgerundet.",
          },
          autoOrder: {
            title: "Automatische Tagesbestellung",
            description: "Täglich um 20:00 Uhr werden Min/Max-Artikel automatisch anhand des aktuellen Bedarfs bestellt — nach derselben Logik wie „Bedarf synchronisieren\". Eingeschlossen sind dabei auch Artikel, die zu diesem Zeitpunkt unter ihrem Mindestbestand liegen, selbst wenn sie nicht manuell hinzugefügt wurden.",
          },
        },
      },
    },
    consumption: {
      notFoundError: "Verbrauch nicht gefunden",
      acceptError: "Verbrauch konnte nicht bestätigt werden: {error}",
      accepted: "Verbrauch {referenceCode} bestätigt",
      retryExport: "Verbrauch exportieren",
      retryingExport: "Verbrauchsexport wird erneut versucht...",
      exportSuccess: "Verbrauchsexport erfolgreich: {referenceCode}",
      exportRetryError: "Export des Verbrauchs konnte nicht wiederholt werden: {error}",
      cancelExport: "Verbrauchsexport abbrechen",
      exportCancelError: "Verbrauchsexport konnte nicht abgebrochen werden: {error}",
      exportCancelled: "Verbrauchsexport {referenceCode} abgebrochen",
      nonBillableDescription: "Dieser Verbrauch wird nicht in der Abrechnung berücksichtigt; lediglich für die Bestandsführung.",
    },
    "consumption-create": {
      consumptionSaving: "Verbrauch wird gespeichert...",
    },
    "item-label": {
      captureTitle: "Etikett erfassen",
      confirm: "Etikett hinzufügen",
    },
    itemBlock: {
      deleteConfirmTitle: "Artikelblock löschen",
      deleteConfirmMessage: "Sind Sie sicher, dass Sie den Artikelblock '{itemBlockName}' ({itemBlockCode}) löschen möchten?",
      deletedSuccessfully: "Artikelblock '{itemBlockCode}' erfolgreich gelöscht"
    },
    statistics: {
      labels: {
        itemIssues: "Verbrauch / Woche",
        maxStock: "Max-Bestand",
        today: "Heute",
      },
    },
  },
};

export default messages;
